import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CandidateService } from '@career/core/services/candidate.service';

export type WithdrawDialogData = {
  opportunityId: string;
} & ({ variant: 'dashboard'; token?: never } | { variant: 'invite'; token: string });

interface WithdrawReason {
  code: string;
  reason: string;
  requiresDetails?: boolean;
}

@Component({
  selector: 'app-withdraw-dialog',
  templateUrl: './withdraw-dialog.component.html',
  styleUrls: ['./withdraw-dialog.component.scss']
})
export class WithdrawDialogComponent implements OnInit {
  selectedReason: WithdrawReason;
  otherReason = '';
  loading = false;
  error: string;
  body = "We are sorry if this role or company does not suit what you are looking for. If you could let us know what is missing or lacking we will better suit your roles in the future.";
  reasons = [
    {
      code: "NOTMATCHQUALIFICATIONS",
      reason: "This role doesn't match my qualifications"
    },
    {
      code: "CANDIDATENOINTEREST",
      reason: "This role doesn't interest me"
    },
    {
      code: "CANDIDATENOINTEREST",
      reason: "The company doesn't reflect my values or suit my needs"
    },
    {
      code: "SALARYEXPECTATIONS",
      reason: "The salary and/or benefits don't suit me"
    },
    {
      code: "OTHER",
      reason: "Other",
      requiresDetails: true
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WithdrawDialogData,
    private dialogRef: MatDialogRef<WithdrawDialogComponent>,
    private candidateService: CandidateService
  ) {
    if (this.data.variant === 'dashboard') {
      this.body = "We are sorry if this role or company does not suit what you are looking for anymore. If you could let us know what is missing or lacking we will better suit your roles in the future.";
      this.reasons = [
        {
          code: "OTHER",
          reason: "Poor communication"
        },
        {
          code: "OTHER",
          reason: "Complicated application process"
        },
        {
          code: "SALARYEXPECTATIONS",
          reason: "The compensation and or benefits don't suit me anymore"
        },
        {
          code: "OTHER",
          reason: "Other",
          requiresDetails: true
        }
      ];
    }
  }

  ngOnInit(): void {}

  submit(): void {
    if (this.data.variant === 'invite' && !this.data.token?.trim()) {
      this.error = 'Invalid invite token. Please reopen your invitation link.';
      return;
    }
    let code = this.selectedReason.code;
    let reason = this.selectedReason.reason;
    if (this.selectedReason.requiresDetails) {
      reason = this.otherReason;
    }
    this.loading = true;
    this.error = null;
    this.candidateService.withdrawInterest(this.data.opportunityId, { code, reason }, this.data.token).subscribe({
      next: (dto) => {
        this.loading = false;
        this.dialogRef.close(dto);
      },
      error: (err) => {
        this.loading = false;
        this.error = err?.error?.message || 'An error occurred. Please try again.';
      }
    });
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
